export default "__VITE_ASSET__CxZqQ4qi__"